module.exports = __webpack_public_path__ + "static/media/googleplay_button.f961146f.png";